import { register } from 'register-service-worker';
import firebase from 'firebase/app';
import 'firebase/messaging';
import Store from '@/store';

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}firebase-messaging-sw.js`, {
    ready() {

    },
    registered(registration) {
      firebase.initializeApp({
        apiKey: 'AIzaSyCC4fN-9XqgDj064Rp0_05engXufyOwgQo',
        authDomain: 'iwaly-31a12.firebaseapp.com',
        databaseURL: 'https://iwaly-31a12.firebaseio.com',
        projectId: 'iwaly-31a12',
        storageBucket: 'iwaly-31a12.appspot.com',
        messagingSenderId: '369127635749',
        appId: '1:369127635749:web:bd8b76edc30fcf310038cc',
      });
      const messaging = firebase.messaging();
      messaging.useServiceWorker(registration);
      messaging.requestPermission().then(() => {
        Store.dispatch('firebase/ACT_SET_MESSAGING', {
          messaging,
        }, { root: true });
      });
    },
    cached() {

    },
    updatefound() {

    },
    updated() {

    },
    offline() {

    },
    error() {

    },
  });
}
